

import Alert from 'react-s-alert'
import { SendNotificationParams } from './base'

export const sendWebNotification = (params: SendNotificationParams) => {
    Alert.info('', {
        customFields: params,
        position: 'bottom-right',
        effect: 'stackslide',
        html: true,
    })
}